export function isEnglish() {
  if (window.location.href.toLowerCase().indexOf("/en/") > -1) {
    return true;
  } else {
    return false;
  }
}
